import React, { Component } from "react";
import { CardElement, injectStripe } from "react-stripe-elements";
import { Modal, Button } from "react-bootstrap";
import messages from "./CheckoutForm.messages";
import GradientButton from "../../../components/input/GradientButton";

type Props = {
  updateCustomer: (token: string) => void,
  createCustomer: (token: string, coupon: string) => void,
  isNewCustomer: boolean,
  onModalClose: () => void,
  showIncorrectCouponError: boolean,
  validateCoupon: (coupon: string) => void,
  showCouponSuccess: boolean,
  isCreatingCustomer: boolean,
  isCreatingSubscription: boolean,
};

type State = {
  coupon: string,
  showCoupon: boolean,
};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  state: State = {
    coupon: "",
    showCoupon: false,
    isSubmitting: false,
  };

  handleCouponChange = (event) => {
    this.setState({ coupon: event.target.value });
  };

  handleCouponClick = (event) => {
    event.preventDefault();
    this.setState({ showCoupon: true });
  };

  handleSubmit = (isSubmitting: boolean) => {
    this.setState({ isSubmitting: isSubmitting });
  };

  validateCoupon = () => {
    this.props.validateCoupon(this.state.coupon);
  };

  getSubmitMessage = () => {
    if (this.state.isSubmitting) {
      return "Loading...";
    } else {
      return "Submit";
    }
  };

  async submit(ev) {
    this.handleSubmit(true);
    let { token } = await this.props.stripe.createToken();
    if (token != null) {
      if (this.props.isNewCustomer) {
        this.props.createCustomer(token.id, this.state.coupon);
      } else {
        this.props.updateCustomer(token.id);
      }
    } else {
      this.handleSubmit(false);
    }
  }

  render() {
    return (
      <div className="checkout">
        <Modal.Body>
          <CardElement />
          {this.props.isNewCustomer ? this.renderCoupon() : null}
        </Modal.Body>
        <Modal.Footer>
          <GradientButton
            gradient="0/1"
            handleClick={this.props.onModalClose}
            title="Cancel"
          />
          <GradientButton
            disabled={this.state.isSubmitting}
            gradient="1/1"
            handleClick={this.submit}
            title={this.getSubmitMessage()}
          />
        </Modal.Footer>
      </div>
    );
  }

  renderCoupon() {
    return (
      <div className="row">
        <div className="col-md-6 col-lg-4 m-t-15">
          {this.state.showCoupon
            ? this.renderCouponSection()
            : this.renderCouponButton()}
        </div>
      </div>
    );
  }

  renderCouponButton() {
    return (
      <div>
        <a href="" onClick={this.handleCouponClick}>
          {messages.addCoupon}
        </a>
      </div>
    );
  }

  renderCouponSection() {
    return (
      <div>
        {this.props.showCouponSuccess
          ? this.renderSuccess()
          : this.renderCouponInput()}
      </div>
    );
  }

  renderCouponInput() {
    return (
      <div className="form-group">
        <label className="control-label">{messages.code}</label>
        <div className="input-group">
          <input
            className={
              this.props.showIncorrectCouponError
                ? "form-control is-invalid"
                : "form-control"
            }
            type="text"
            name={messages.code}
            onChange={this.handleCouponChange}
          />
          <div className="input-group-append">
            <GradientButton
              gradient="59/60"
              handleClick={this.validateCoupon}
              title="+"
            />
          </div>
          <div className="invalid-feedback">{messages.couponError}</div>
        </div>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <p className="text-success">{messages.couponSuccess}</p>
      </div>
    );
  }
}

export default injectStripe(CheckoutForm);



// WEBPACK FOOTER //
// ./src/components/forms/checkout-form/CheckoutForm.js